import { render, staticRenderFns } from "./MRMedia.vue?vue&type=template&id=8704ab2e&scoped=true"
import script from "./MRMedia.vue?vue&type=script&lang=ts"
export * from "./MRMedia.vue?vue&type=script&lang=ts"
import style0 from "./MRMedia.vue?vue&type=style&index=0&id=8704ab2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8704ab2e",
  null
  
)

export default component.exports